import { render, staticRenderFns } from "./dialogMagazzini.vue?vue&type=template&id=ae64d2c8&scoped=true"
import script from "./dialogMagazzini.vue?vue&type=script&lang=js"
export * from "./dialogMagazzini.vue?vue&type=script&lang=js"
import style0 from "./dialogMagazzini.vue?vue&type=style&index=0&id=ae64d2c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae64d2c8",
  null
  
)

export default component.exports